export default __webpack_public_path__ + "static/media/crown.5cecfff5.png";